import { Button } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import PinInput from "react-pin-input";
import { formatString, validateInputs } from "../../../utils/constant";

const PinCodeForm = ({
  handleSubmitPinCode,
  isLoading,
  errorMessage,
  handleAlertClose,
  setErrorMessage,
  handleMove,
  setFormState,
}) => {
  const [pinCode, setPinCode] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  // This function handles the form submission for submitting the pin code. The flow of this function is as follows:
  // 1. Prevents the default form submission behavior (e.preventDefault()).
  // 2. Creates a `FormData` object with the pin code entered by the user.
  // 3. Defines a list of required input fields, in this case, the pin code ("pinCode").
  // 4. Validates the input fields using the `validateInputs` function, which checks if the required fields are filled.
  // 5. If there are validation errors (e.g., missing pin code), it displays an error notification with the missing field.
  // 6. If the pin code is not entered, it sets an error message and displays a notification to prompt the user to enter the pin code.
  // 7. If no errors, it proceeds to call the `handleSubmitPinCode` function with the pin code as an argument.
  const handleSubmit = (e) => {
    e.preventDefault();
    const FormData = {
      pinCode: pinCode,
    };
    const requiredStringInputFields = ["pinCode"];
    const errors = validateInputs(FormData, requiredStringInputFields, [], []);
    if (!(Object.keys(errors).length === 0)) {
      enqueueSnackbar(formatString(Object.keys(errors)[0]) + " is required", {
        variant: "error",
      });
      return;
    }

    if (!pinCode) {
      setErrorMessage("Please enter your pin code");
      enqueueSnackbar("Please enter your pin code", { variant: "error" });
      handleMove();
      return;
    }
    handleSubmitPinCode(pinCode);
  };

  return (
    <>
      <div className="  " id="handle_move">
        <div className=" ">
          <form onSubmit={handleSubmit}>
            <div className="col-12   pt-4 ">
              <div className="mb-3">
                <label className="form-label">Enter PIN Code here. *</label>
                <PinInput
                  length={6}
                  secret={false}
                  onChange={(value, index) => setPinCode(value)}
                  type="numeric"
                  inputMode="number"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  inputStyle={{ borderColor: "#fff" }}
                  // inputFocusStyle={{ borderColor: "#438a7a" }}
                  inputFocusStyle={{ borderColor: "#fff", color: "#fff" }}
                  onComplete={(value, index) => {
                    setPinCode(value);
                  }}
                  autoSelect={true}
                  regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                />
              </div>
              <div className="col-12 mt-2">
                <div className="position-relative">
                  {/* Wait, I remember my password */}
                  <div
                    className="float-end pb-2 pointer"
                    onClick={() => {
                      localStorage.setItem("state", -1);
                      setFormState(-1);
                    }}
                  >
                    {/* eslint-disable-next-line */}
                    <a className="text-muted">Back to Login </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <Button
                type="submit"
                variant="contained"
                className="w-100 login-page-button"
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Submit"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default PinCodeForm;
